import { Toaster as SonnerToaster } from "sonner";

import { platformProps } from "../../lib";
import type { ToasterPrimitiveProps } from "./types";

export function ToasterPrimitive({
  position = "bottom-left",
  visibleToasts = 1,
  duration = 4000,
  offset,
  className,
  testID,
}: ToasterPrimitiveProps) {
  const toaster = (
    <SonnerToaster
      position={position}
      visibleToasts={visibleToasts}
      duration={duration}
      offset={offset}
      className={className}
      closeButton={false}
      toastOptions={{ unstyled: true }}
    />
  );
  // sonner's Toaster forwards nothing but its named props, so a test ID needs
  // its own node; `display: contents` keeps it out of layout
  if (!testID) return toaster;
  return (
    <div style={{ display: "contents" }} {...platformProps({ testID })}>
      {toaster}
    </div>
  );
}
